"use client"

/**
 * 09 — Real results from real people. Figma 329:15822, an 838px band. The
 * rail itself is shared (`components/ui/reviews-rail.tsx`) so the other main
 * pages show testimonials the same way; this block adds the homepage's copy
 * and its band. Every card is a real CMS testimonial — see
 * `home-v4-reviews-data.ts`.
 */

import { useLocalePath } from "@/lib/use-localized-navigation"
import { ReviewsRail } from "@/components/ui/reviews-rail"
import { useHomeV4Copy } from "./home-v4-copy"
import type { HomeV4Review } from "./home-v4-reviews-data"

export function HomeV4Reviews({
  section,
  reviews,
}: {
  section: string
  reviews: HomeV4Review[]
}) {
  const lp = useLocalePath()
  const { REVIEWS } = useHomeV4Copy()
  return (
    // 160 above the eyebrow on desktop, the same as under the practical
    // section's last card (Eugene, 11.09).
    <ReviewsRail
      section={section}
      className="bg-white pt-10 pb-10 md:pt-[75px] md:pb-[114px] lg:pt-[160px]"
      eyebrow={REVIEWS.eyebrow}
      heading={REVIEWS.heading}
      ctaLabel={REVIEWS.cta}
      ctaHref={lp("/reviews")}
      followersSuffix={REVIEWS.followersSuffix}
      reviews={reviews}
    />
  )
}
